import axios from 'axios';
import { I18n } from 'react-redux-i18n';
import { push } from 'react-router-redux';

// Constants.
import * as PayProductsConstants from 'constants/PayProductsConstants';

// Actions.
import * as ProfileActions from 'actions/ProfileActions';
import * as PayHistoryActions from 'actions/PayHistoryActions';
import * as PayConnectedPackagesActions from 'actions/PayConnectedPackagesActions';
import * as AlertActions from 'actions/AlertActions';

function requestLoadProducts() {
  return {
    type: PayProductsConstants.LOAD_PRODUCTS_REQUEST,
  };
}

function receiveLoadProducts(products, activeProducts, paidProduct) {
  return {
    type: PayProductsConstants.LOAD_PRODUCTS_SUCCESS,
    products,
    activeProducts,
    paidProduct,
  };
}

function receiveLoadProductsError(message) {
  return {
    type: PayProductsConstants.LOAD_PRODUCTS_FAILURE,
    message,
  };
}

export function loadProducts() {
  return dispatch => {
    dispatch(requestLoadProducts());
    axios({
      method: 'GET',
      url: '/dashboard_api/v1/billing/products_v2/',
    })
      .then((response) => {
        const products = response.data;
        const activeProducts = [];
        let paidProduct = null;
        products.map((product) => {
          if (product.slug === 'welltorygift') {
            return false
          }
          if (product.active === true) {
            activeProducts.push(product);
          }
          if (product.is_paid === true && product.active === false) {
            paidProduct = { ...product };
          }
          return false;
        });
        const sortedProducts = activeProducts.sort((a, b) => {
          if (/monthly-subscription/.test(a.slug) && /yearly-subscription/.test(b.slug)) {
            return -1;
          }
          else if (/yearly-subscription/.test(a.slug) && !b.interval) {
            return -1;
          }
          else if (/monthly-subscription/.test(a.slug) && !b.interval) {
            return -1;
          }
          return 1;
        });
        dispatch(receiveLoadProducts(products, sortedProducts, paidProduct));
      })
      .catch((error) => {
      });
  };
}

function requestPayProduct(productId) {
  return {
    type: PayProductsConstants.PAY_PRODUCT_REQUEST,
    productId,
  };
}

function receivePayProduct() {
  return {
    type: PayProductsConstants.PAY_PRODUCT_SUCCESS,
  };
}

function receivePayProductError(message) {
  return {
    type: PayProductsConstants.PAY_PRODUCT_FAILURE,
    message,
  };
}

export function payProduct(product, coupon = '', stripeToken, stripe3dToken) {
  return (dispatch, getState) => {
    dispatch(requestPayProduct(product.id));
    const body = {
      productId: product.id,
    };
    const { coupons, router: { location } } = getState();
    if (coupon.length > 0 && coupons.coupons[product.id] && coupons.coupons[product.id][coupon] && coupons.coupons[product.id][coupon].success === true) {
      body.coupon = coupon;
    }
    if (stripeToken) {
      body.stripeToken = stripeToken;
    }
    if (stripe3dToken) {
      body.stripe3dToken = stripe3dToken;
    }
    axios.post('/dashboard_api/v1/billing/pay/', body)
      .then((response) => {
        setTimeout(() => {
          dispatch(receivePayProduct());
          dispatch(loadProducts());
          dispatch(ProfileActions.loadUserProfile());
          dispatch(PayHistoryActions.loadPayHistory());
          dispatch(PayConnectedPackagesActions.loadPayConnectedPackages());
          dispatch(push({ pathname: location.pathname }));
          if (product.slug === 'welltorygift') {
            const alertMessage = I18n.t('Спасибо за покупку сейчас вам  отправим код');
            dispatch(AlertActions.sendAlertMessage(alertMessage));
          }
        }, 10000);
      })
      .catch((error) => {
        if (error.response) {
          const detail = error.response.data.error ? error.response.data.error : error.response.data.detail;
          const errorMessage = `${detail} (${error.response.status})`;
          dispatch(receivePayProductError(errorMessage));
        }
      });
  };
}

export function clearMessage() {
  return dispatch => {
    dispatch(receivePayProductError(''));
  }
}
